import { OAuthConfig } from '../../types';

/* TODO: extract some to OidcService / KeycloakService */
export default abstract class OAuthService {
  clientId: OAuthConfig['clientId'];
  clientSecret: OAuthConfig['clientSecret'];
  endpointBase: string;

  /*  */
  constructor({ clientId, clientSecret, serverRealm, serverUrl }: OAuthConfig) {
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.endpointBase = this._endpointBaseGet(serverUrl, serverRealm);
  }

  /*  */
  _endpointBaseGet(serverUrl: OAuthConfig['serverUrl'], serverRealm: OAuthConfig['serverRealm']) {
    return `${serverUrl}/realms/${serverRealm}/protocol/openid-connect`;
  }

  /*  */
  abstract fetch(input: RequestInfo | URL, init?: RequestInit | undefined): Promise<any>;

  /*  */
  formFill(fields: [string, string][]) {
    const form = this.formInit();

    /*  */
    let idx: number | undefined = fields.length - 1;
    let arr: [string, string] | undefined = undefined;

    while (idx >= 0) {
      arr = fields[idx];
      form.append(arr[0], arr[1]);
      --idx;
    }

    return form;
  }

  /*  */
  formInit() {
    const form = new URLSearchParams();
    form.append('client_id', this.clientId);
    form.append('client_secret', this.clientSecret);
    return form;
  }

  /*  */
  formResponseProcess(response: Response) {
    return response.text();
  }

  /*  */
  formSend(path: string, fields: [string, string][]) {
    const form = this.formFill(fields);
    return this.fetch(
      `${this.endpointBase}${path}`,
      {
        body: form,
        credentials: 'omit',
        headers: this.headersInit(),
        method: 'POST',
      }
    );
  }

  /*  */
  async formSendAndProcess(path: string, fields: [string, string][]) {
    return this.formResponseProcess(await this.formSend(path, fields));
  }

  /*  */
  headersInit() {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return headers;
  }
}